<template>
  <div style="background:#eeeeee;padding:20px;">
    <div>
      <div class="homeRox overBox">
        <div class="homeCol homeCol3">
          <Card style="width:100%;height:280px">
            <span slot="title">
              <Icon type="md-people" size="22" style="margin-right:10px" /><!-- 团队情况 -->{{$t('My_Team')}}
            </span>
            <span slot="extra">
              <router-link  to="/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27"><!-- 查看更多 -->{{$t('Select_More')}}</router-link>
            </span>
            <div class="team">
              <div class="teamBox" v-for="(item,index) in teamList" :key="index">
                <Avatar  v-if="item.portrait" :src="'data:image/jpeg;base64,' + item.portrait || ''"  size="large"/>
                <Avatar v-else icon="ios-person" size="large" />
                <div class="teamContent"><span>{{lang=='zh'?item.userName:item.userEName}}</span> <p>{{ lang=='zh'?item.position:item.enPosition }} {{ lang=='zh'?item.businessUnit:item.enBusinessUnit }}</p> </div>
              </div>
            </div>
          </Card>
        </div>
        <div class="homeCol homeCol7">
          <Card style="width:100%;height:280px">
            <p slot="title">
              <Icon type="ios-podium" size="22" style="margin-right:10px"/><!-- 绩效正态分布 -->{{$t('Normal_Distribution_of_Performance')}}
            </p>
            <span slot="extra">
              <router-link  to="/A8E9DCF043CE767F05D716BD894E6E2DA1F5FE9AF7628B41/A3FFBEBFDB713E27"><!-- 查看更多 -->{{$t('Select_More')}}</router-link>
            </span>
            <div id="barRightChart" :style="{ width: '100%', height: '170px' }"></div>
          </Card>
        </div>
      </div>
      <div class="homeRox ">
        <div class="homeCol homeCol3">
          <Card style="width:100%;height:280px">
            <p slot="title">
              <Icon type="md-pie" size="22" style="margin-right:10px" /><!-- 绩效状态管理 -->{{$t('Performance_Status')}}
            </p>
            <div slot="extra" style="display:flex;align-items: center;"><span style="width:100%"><!-- 当前状态 -->{{$t('Status_Now')}}：</span>
              <Select v-model="achStageStatus" @on-change="getPerformanceManage">
                  <Option v-for="(item,index) in stateList" :value="item.ch_value" :key="index">{{ lang=='zh'?item.ch_value: item.en_value }}</Option>
              </Select>
            </div>
            <div id="pieRightChart" :style="{ width: '100%', height: '180px' }"></div>
          </Card>
        </div>
        <div class="homeCol homeCol7">
          <Card style="width:100%;height:280px;" class="successorCard">
            <p slot="title">
              <Icon type="md-keypad" size="22" style="margin-right:10px"/><!-- 继任者盘点 -->{{$t('Successors_Info')}}
            </p>
            <span slot="extra">
              <router-link  :to="{path:'/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27',query:{pageLink:'name2'}}"><!-- 查看更多 -->{{$t('Select_More')}}</router-link>
            </span>
            <SuccessorComponent ref="SuccessorComponent"></SuccessorComponent>
          </Card>
        </div>
      </div>
      <div class="homeRox">
        <div class="homeCol">
          <Card style="width:100%;height:260px">
            <p slot="title">
              <Icon type="md-person" size="22" style="margin-right:10px"/><!-- 我的信息 -->{{$t('My_Information')}}
            </p>
            <div class="myinfoBox">
              <div class="myinfoCol myinfoCol1">
                <!-- to="/E97C32785C9AE39059617F3F1DC697B475A259E7C679B2FA/A3FFBEBFDB713E27"  暂时取消我的信息个人档案跳转-->
                <router-link style="width:100%;display:contents" to="/E97C32785C9AE39059617F3F1DC697B475A259E7C679B2FA/A3FFBEBFDB713E27" >
                    <img v-if="portrait" :src="'data:image/jpeg;base64,' + portrait || ''" />
                    <img v-else src="@/assets/headerImg.png" />
                    <!-- <div class="myinfoDate"> 出生日期 {{$t("Date_of_Birth")}} <p>照片上传暂未开放</p></div>-->  <!-- {{birthday}} -->
                </router-link>
              </div>
              <router-link style="width:100%;display:contents" to="/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27">
                  <div class="myinfoCol myinfoCol2">
                      <div class="myinfoTit"><!-- 我的绩效 -->{{$t('My_Performance')}}</div>
                      <div class="myinfoIcon">
                        <Icon type="ios-list-box" style="color:white" size="50" />
                      </div>
                  </div>
              </router-link>
              <router-link style="width:100%;display:contents" to="/A8E9DCF043CE767F05D716BD894E6E2DA1F5FE9AF7628B41/A3FFBEBFDB713E27">
                  <div class="myinfoCol myinfoCol3">
                      <div class="myinfoTit"><!-- 员工绩效 -->{{$t('Employee_Performance')}}</div>
                      <div class="myinfoIcon">
                        <Icon type="md-paper" style="color:white" size="50" />
                      </div>
                  </div>
              </router-link>
              <!-- 原： 员工档案 to="/E97C32785C9AE39069688FE26FE50DC4290AFBCB10607085/A3FFBEBFDB713E27"  新 ： 跳转持续沟通-->
               <!-- 原： 持续沟通 to="/C0F994D621530A70/A3FFBEBFDB713E27"  新 ： 跳转新持续沟通-->
              <router-link style="width:100%;display:contents" to="/61AB63E6DE1EF633AB0757BB3048AF07B7578999FE53335EBA610C6A6F738319/A3FFBEBFDB713E27">
                <!-- <router-link style="width:100%;display:contents" to="/C0F994D621530A70/A3FFBEBFDB713E27"> -->
                  <div class="myinfoCol myinfoCol4">
                      <div class="myinfoTit"><!-- 员工档案 -->{{$t('Continuous_Dialogues')}}</div>
                      <div class="myinfoIcon">
                        <Icon type="md-trending-up" style="color:white" size="50" />
                      </div>
                  </div>
              </router-link>
            </div>
          </Card>
        </div>
        <div class="homeCol">
          <Card style="width:100%;height:260px">
            <div slot="title"> <Icon type="md-menu" size="22"  style="margin-right:10px"/><!-- 我的审批 -->{{$t('My_Approval')}}<Badge style="margin-left:10px" :count="approvalList.length"></Badge> </div>
            <span slot="extra">
              <router-link  to="/5BCC4A27AC412B7E84A39B5ED0BC758ABA610C6A6F738319/A3FFBEBFDB713E27"><!-- 查看更多 -->{{$t('Select_More')}}</router-link>
            </span>
            <vue-seamless-scroll :data="approvalList" :class-option="classOption"  class="seamless-warp" >
              <ul class="item">
                <li v-for="(item, index) in approvalList" :key="index" :data-id="item.id">
                  <div class="download_outer">
                    <div class="download_left">
                      <Avatar style="background-color: #fcce10" size="small" icon="ios-megaphone"/>
                      <div class="title">{{ item.applyName }}</div>
                      <div> {{ date.dateVal(item.updated_date, "YYYY/MM/DD") }} </div>
                    </div>
                    <router-link :to="{path:'/'+item.pageInfo, query: { id: item.id ,serialnumber:item.serialnumber,beUpdateFlag:item.beUpdateFlag,achStage:item.achStage}}">
                    <div> <Icon type="ios-arrow-forward" size="18" /> </div>
                    </router-link>
                  </div>
                  <Divider dashed />
                </li>
              </ul>
            </vue-seamless-scroll>
          </Card>
        </div>
      </div>
    </div>
    <!-- <StaffView></StaffView> -->
    <!-- <ProgressComponent></ProgressComponent> -->
  </div>
</template>

<script>
import "./js/westerosGreen.js";
import SuccessorComponent from "./components/SuccessorComponent";
import StaffView from "./components/StaffView";
import DateUtil from "@/util/DateUtil";
import ProgressComponent from "@/components/bipage/components/ProgressComponent";

import axios from "axios";
export default {
  components: { SuccessorComponent, ProgressComponent,StaffView },
  data() {
    return {
      date: new DateUtil(),
      achStageStatus:'目标设定',
      stateList:[],
      teamList:[],
      lineData:[],
      dataChart:[],
      beStartNum:null,
      ongoingNum:null,
      finishNum:null,
      approvalList:[],
      birthday:'',
      portrait:'',
      total:0
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.3,
        limitMoveNum: 4,
        openWatch: true
      };
    },
    lang(){
        return this.$store.getters.selectLangeData
    }
  },
  watch: {
      '$i18n.locale'(newValue) {
            this.$nextTick(() => {
              this.barRightChart();
              this.pieRightChart()
            })
      }
  },
  mounted() {
    this.getTeamList()
    this.getChartData()
    this.getPerformanceManage()
    this.getApprovalData()
    this.birthday=this.date.dateVal(JSON.parse(sessionStorage.getItem('userInfo')).birthday,"YYYY/MM/DD")
    this.portrait=JSON.parse(sessionStorage.getItem('userInfo')).portrait
  },
  methods: {
    getTeamList(){
      axios.post("/teamInfo/selectTeamInfo", {}).then((res) => {
          if(res){
              this.teamList=res.employeeList
          }
      })
    },
    getChartData(){
      axios.post('/achReport/selectReportAchAssess', {}).then(res => {
        this.total = parseInt(res.pageInfo.total)
          this.dataChart=res.achNormalList
          this.dataChart.forEach(el => {
            this.lineData.push(el.peopleNum)
          })
          this.barRightChart();
          
       })
    },
    getPerformanceManage(){
      axios.post("/achLenderCockpit/selectAchAdminister", {achStageStatus:this.achStageStatus}).then((res) => {
          if(res){
              this.beStartNum=res.beStartNum
              this.ongoingNum=res.ongoingNum
              this.finishNum=res.finishNum
              this.stateList=res.achStage
              this.pieRightChart();
          }
      })
    },
    getApprovalData(){
      axios.post("/achLenderCockpit/selectApprovalList", {}).then((res) => {
          if(res){
              this.approvalList=res
          }
      })
    },
    pieRightChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("pieRightChart"),
        "westerosGreen"
      );
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          top: "1%",
          left: "left",
          orient: "vertical"
        },
        series: [
          {
            name: this.$t('Objective_state_management'),/* 目标状态管理 */
            type: "pie",
            radius: ["40%", "70%"],
            // avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            // label: {
            //     show: true,
            //     position: 'center'
            // },
            emphasis: {
              label: {
                show: true,
                fontSize: "24",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true,
              length:10
            },
            data: [
              {
                value: this.beStartNum,
                itemStyle: {
                  color: "#ED7D31"
                },
                name: this.$t('Not_start')/* 未开始 */
              },
              {
                value: this.finishNum,/* this.finishNum */
                itemStyle: {
                  color: "#7CB144"
                },
                name: this.$t('Finished')/* 已完成 */
              },
              {
                value: this.ongoingNum,/* this.ongoingNum */
                itemStyle: {
                  color: "#2F75B5"
                },
                name: this.$t('In_progress')/* 进行中 */
              }
            ]
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    barRightChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("barRightChart"),"westeros");
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.$t('Normal_Distribution_of_Performance'),
          left: "center",
          top: "0",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "6%",
          right: "6%",
          top: "12%",
          bottom: "12%"
        },
        xAxis: [
          {
            type: "category",
            // data: ["1-需要改善","2-部分达标","3-达到要求","4-超越要求","5-优秀出色"],
            data: [
              this.$t('PB_1-Requires_Improvement'),
              this.$t('PB_2-Typically_Meets'),
              this.$t('PB_3-Achieved'),
              this.$t('PB_4-Exceeds'),
              this.$t('PB_5-Exceptional'),
            ],
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: this.total.toString().length==1?10:this.total.toString().length==2?100:this.total.toString().length==3?1000:this.total.toString().length==4?10000:100000,
            interval: this.total.toString().length==1?1:this.total.toString().length==2?10:this.total.toString().length==3?100:this.total.toString().length==4?1000:10000,
            // axisLabel: {
            //   formatter: "{value}"
            // }
          },
          // {
          //   type: "value",
          //   min: 0,
          //   max: 100,
          //   interval: 10,
          //   axisLabel: {
          //     formatter: "{value}%"
          //   }
          // }
        ],

        series: [
          {
            name: this.$t('PB_Number'),/* 人数 */
            type: "bar",
            barWidth: "50%",
            color: "#4ea397",
            data: [
              {
                value: this.dataChart[0].peopleNum,
                itemStyle: {
                  color: "#A5A5A5"
                }
              },
              {
                value: this.dataChart[1].peopleNum,
                itemStyle: {
                  color: "#D9A300"
                }
              },
              {
                value: this.dataChart[2].peopleNum,
                itemStyle: {
                  color: "#8CD29B"
                }
              },
              {
                value: this.dataChart[3].peopleNum,
                itemStyle: {
                  color: "#fc8637"
                }
              },
              {
                value: this.dataChart[4].peopleNum,
                itemStyle: {
                  color: "#4472C4"
                }
              }
            ]
          },
          {
            name: this.$t('PB_Number'),/* 人数 */
            type: "line",
            color: "#006B37",
            data: this.lineData,
            tooltip: {
              show:false
            }
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>

<style lang="scss" scoped>

.homeRox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .homeCol {
    width: 49%;
    .team {
      height: 210px;
      overflow-y: auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-items: flex-start;
      align-content: flex-start;
    }
    .teamBox {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      margin: 5px 0;
      .teamContent {
        width: calc(100% - 40px - 20px);
        height: 60px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
        margin: 0 10px;
      }
    }
  }
  .homeCol7 {
    width: 64%;
  }
  .homeCol3 {
    width: 34%;
  }
}
.myinfoBox {
  display: flex;
  justify-content: space-between;
  padding: 0px;
  box-sizing: border-box;
}
.myinfoCol {
  width: 24%;
  background: #ffffff;
  border-radius: 8px;
  height: 180px;
  padding: 10px;
  box-sizing: border-box;
  // border-left: 5px solid #4ea397;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .myinfoTit {
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
  }
  .myinfoIcon {
    display: flex;
    justify-content: flex-end;
  }
}
.myinfoCol1 {
  background-color: #eeeeee;
  position: relative;
  padding: 0;
  display: flex;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 180px;
    border-radius: 8px;
  }
  .myinfoDate {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 25px;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.4);
    padding: 5px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
  }
}
.myinfoCol2 {
  background-color: #4ea397;
}
.myinfoCol3 {
  background-color: #22c3aa;
}
.myinfoCol4 {
  background-color: #7bd9a5;
}
.seamless-warp {
  // height: calc(100vh - 360px - 51px - 64px);
  height: 200px;
  overflow: hidden;
  .item {
    .download_outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .download_left {
        display: flex;
        align-items: center;
        .title {
          font-size: 12px;
          color: #000000;
          margin-bottom: 10px;
          font-weight: normal;
        }
        h2 {
          font-size: 12px;
          color: #000000;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 15px;
        }
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
>>> .seamless-warp {
  // height: calc(100vh - 360px - 51px - 64px);
  height: 180px;
  overflow: hidden;
  .item {
    .download_outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .download_left {
        display: flex;
        align-items: center;
        .title {
          font-size: 12px;
          color: #000000;
          //   margin-bottom: 10px;
          font-weight: normal;
          margin: 0 12px;
        }
        h2 {
          font-size: 12px;
          color: #000000;
        }
        img {
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
>>> .ivu-divider-horizontal {
  margin: 8px 0;
}
@media screen and (max-width: 1440px) {
  .homeRox {
    display: flex;
    flex-wrap: wrap;
    .homeCol {
      width: 100%;
      .team {
        height: 200px;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;
        align-items: flex-start;
        align-content: flex-start;
      }
      .teamBox {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        margin: 10px 0;
        .teamContent {
          width: calc(100% - 40px - 20px);
          height: 60px;
          border: 1px solid #eeeeee;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          padding: 10px;
          box-sizing: border-box;
          margin: 0 10px;
        }
      }
    }
    .homeCol7 {
      width: 100%;
    }
    .homeCol3 {
      width: 100%;
    }
  }
}
.overBox ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.overBox ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
.overBox ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
.successorCard /deep/.ivu-card-body {
  padding: 0 10px !important;
}
#barRightChart{
  zoom:1.18 !important
}
#pieRightChart{
  zoom:1.18 !important
}
</style>



// WEBPACK FOOTER //
// src/components/index/MenuPageData.vue